import type { Position, RapportStatus, Uebergang } from '@arbeitsrapporte/shared';

export const STATUS_TEXT: Record<RapportStatus, string> = {
  entwurf: 'Entwurf',
  abgeschlossen: 'Abgeschlossen',
  freigegeben: 'Freigegeben',
  verbucht: 'Verbucht',
  storniert: 'Storniert',
};

export const UEBERGANG_TEXT: Record<Uebergang, string> = {
  abschliessen: 'Abschließen',
  zurueckgeben: 'Zurück in den Entwurf',
  freigeben: 'Freigeben',
  stornieren: 'Stornieren',
};

export const ART_TEXT = {
  arbeit: 'Arbeit',
  reise: 'Reise',
  material: 'Material',
  spesen: 'Spesen',
} as const;

export function datumLesbar(iso: string): string {
  const [j, m, t] = iso.slice(0, 10).split('-');

  return `${t}.${m}.${j}`;
}

export function heute(): string {
  const d = new Date();
  const zwei = (n: number) => String(n).padStart(2, '0');

  return `${d.getFullYear()}-${zwei(d.getMonth() + 1)}-${zwei(d.getDate())}`;
}

export function jetztUhr(): string {
  const d = new Date();
  const zwei = (n: number) => String(n).padStart(2, '0');

  return `${zwei(d.getHours())}:${zwei(d.getMinutes())}`;
}

/** Ein Zeitpunkt, wie er in der Schweiz gelesen wird – für Unterschrift und Läufe. */
export function zeitpunktLesbar(iso: string): string {
  return new Date(iso).toLocaleString('de-CH', { dateStyle: 'short', timeStyle: 'short' });
}

/**
 * Was zusammenkommt: Stunden und Kilometer je Einheit, nur die verrechenbaren.
 *
 * Material wird nicht summiert – drei Dichtungen und zwei Meter Kabel
 * ergeben keine Zahl. Gerechnet wird in Tausendsteln, damit 0.1 + 0.2 nicht
 * 0.30000000000000004 ergibt.
 */
export function summen(positionen: readonly Position[]): { einheit: string; menge: string }[] {
  const je = new Map<string, number>();

  for (const p of positionen) {
    if ((p.art !== 'arbeit' && p.art !== 'reise') || !p.verrechenbar) continue;

    const wert = Math.round(Number(p.menge) * 1000);

    if (Number.isNaN(wert)) continue;

    je.set(p.einheit, (je.get(p.einheit) ?? 0) + wert);
  }

  return [...je.entries()].map(([einheit, tausendstel]) => ({
    einheit,
    menge: String(tausendstel / 1000),
  }));
}
